export interface AldanaColorOption {
  name: string;
  value: string;
  hex: string;
}

export const ALDANA_COLOR_OPTIONS: AldanaColorOption[] = [
  { name: 'Rojo', value: 'Rojo', hex: '#ef4444' },
  { name: 'Amarillo', value: 'Amarillo', hex: '#eab308' },
  { name: 'Amarillo claro', value: 'Amarillo claro', hex: '#ffff00' },
  { name: 'Azul', value: 'Azul', hex: '#3b82f6' },
  { name: 'Verde', value: 'Verde', hex: '#22c55e' },
  { name: 'Verde claro', value: 'Verde claro', hex: '#47ff51' },
  { name: 'Violeta', value: 'Violeta', hex: '#8b5cf6' },
  { name: 'Naranja', value: 'Naranja', hex: '#f97316' },
  { name: 'Rosado', value: 'Rosado', hex: '#ec4899' },
  { name: 'Negro', value: 'Negro', hex: '#111827' },
  { name: 'Blanco', value: 'Blanco', hex: '#ffffff' },
  { name: 'Marron', value: 'Marron', hex: '#92400e' }
];
